/**
 * 
 * @param {*} date 
 * @returns 
 */
function getEpoch(date) {
	return Math.floor((date || new Date()).getTime() / 1000);
}

/**
 * 
 * @param {*} mimeType 
 * @returns 
 */
function isImageMimeType(mimeType) {

	if (!mimeType) {
		return false;
	}

	switch(mimeType.trim().toLowerCase())
	{
		default: 
			return false;
		case "image/png":
		case "image/jpeg":
		case "image/gif":
		case "image/svg+xml":
		case "image/webp":
			return true;
	}
}

/**
 * 
 * @param {*} array 
 * @returns 
 */
function shuffle(array) {
  var currentIndex = array.length, randomIndex;

  // While there remain elements to shuffle...
  while (currentIndex !== 0) {

    // Pick a remaining element...
    randomIndex = Math.floor(Math.random() * currentIndex);
    currentIndex--;

    // And swap it with the current element.
    [array[currentIndex], array[randomIndex]] = [
      array[randomIndex], array[currentIndex]];
  }

  return array;
}

/**
 * Checks whether the current device supports touch.
 * Also works with Chrome Dev Tools.
 * 
 * Taken from https://stackoverflow.com/a/52855084
 * 
 * @returns 
 */

function isTouchDevice() {
	return window.matchMedia("(pointer: coarse)").matches;
}

function absURL(relativeUrl) {
	return `${process.env.REACT_APP_ROOT_DIR || ""}${relativeUrl}`;
}

/**
 * List of quiz types
 */
const quizTypes = [
  { value: "Quiz", text: "Quiz" },
  { value: "Poll", text: "Undersökning" },
  { value: "Free", text: "Fritext" },
  { value: "Musicquiz", text: "Music quiz" } //MMQ
];

export {
	getEpoch,
	isImageMimeType,
	shuffle,
	isTouchDevice,
	absURL,
	quizTypes
}